import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { PageHeader, Card, Field, act } from "@/components/common";

export default function ChangePassword() {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return act(() => Promise.reject({ response: { data: { detail: "The two new passwords do not match" } } }));
    if (await act(() => api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password }), "Password changed")) setF({ current_password: "", new_password: "", confirm: "" });
  };
  return (
    <div className="space-y-6">
      <PageHeader overline="Security" title="Change password" explain="Choose a new password only you know. Use at least 8 characters with letters and numbers." />
      <Card className="max-w-md">
        <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
          <Field label="Current password"><Input type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} required data-testid="cp-current" /></Field>
          <Field label="New password"><Input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} required minLength={8} data-testid="cp-new" /></Field>
          <Field label="Type new password again"><Input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required data-testid="cp-confirm" /></Field>
          <Button className="w-full bg-[#0369a1]" data-testid="cp-submit">Save new password</Button>
        </form>
      </Card>
    </div>
  );
}
